var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showNotifications)?_c('a',{staticClass:"link link-bonus",attrs:{"href":"#"},on:{"click":_vm.goToNotifications}},[_c('f7-icon',{attrs:{"icon":"fal fa-bell","size":"16"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }